import { Box, styledComponent } from '@hermes/web-components'
import Avatar from '../../../../../Avatar'

export const SponsoredBanner = styledComponent(Box)(({ theme }) => ({
  backgroundColor: '#F4F5F5',
  padding: '2px 8px',
  borderRadius: '6px',
  fontWeight: 400,
  fontSize: '13px',
  position: 'absolute',
  top: '-30px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  [theme.breakpoints.down('lg')]: {
    top: '-30px'
  }
}))

export const StyledAvatar = styledComponent(Avatar)(({ theme }) => ({
  width: '183px',
  height: '183px',
  [theme.breakpoints.down('lg')]: {
    width: '92px',
    height: '92px'
  },
  ...(theme?.custom?.SearchProfileCard?.avatar ?? {})
}))
